// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.categories-control {\n  margin: 0 0 0 10px;\n  padding: 0;\n  list-style: none;\n  max-height: 240px;\n  overflow-y: scroll;\n}\n\nul.categories-control li {\n  margin: 5px 0;\n  cursor: pointer;\n  color: #888888;\n  word-break: break-all;\n}\n\nul.categories-control li:hover {\n  color: #333333;\n}\n\nul.categories-control li span {\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  margin-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
